import * as url from "./url_helper"
import apiClientInstance from "./api_client"

// Gets the logged in user data from local session
const getLoggedInUser = () => {
    const user = localStorage.getItem("user")
    if (user) return JSON.parse(user)
    return null
}

//is user is logged in
const isUserAuthenticated = () => {
    return getLoggedInUser() !== null
}

// Report App Crash
const reportAppCrash = (data, options) => {
    return apiClientInstance.post(url.POST_REPORT_APP_CRASH, data, options)
}

// App Init Lookup
const appInitLookup = options => {
    return apiClientInstance.get(url.GET_APP_INFO, null, options)
}

// User App Menu
const userAppMenu = options => {
    return apiClientInstance.get(url.GET_USER_APP_MENU, null, options)
}


const getLogin = (data, encDecAlgo) => {
    apiClientInstance.setAuth("")
    return apiClientInstance.get(url.GET_LOGIN, null, {
        headers: { "input-parameters": data },
        encDecAlgo,
    })
}

// Logout User
const postLogout = () => {
    return apiClientInstance.post(url.POST_LOGOUT)
}

// Refresh Token
const refreshToken = () => {
    return apiClientInstance.get(url.POST_REFRESH_TOKEN, null, {
        bypassRefreshLock: true,
        timeout: 60000,
    })
}

//Get User authorized
const getUserAuthorized = options => {
    return apiClientInstance.get(url.GET_USER_AUTHORIZED, null, options)
}


const postForgotPwd = (data, encDecAlgo) => {
    apiClientInstance.setAuth("")
    return apiClientInstance.post(url.POST_FORGOT_PASSWORD, data, { encDecAlgo })
}

const postResetPwd = (data, encDecAlgo) => {
    return apiClientInstance.post(url.POST_RESET_PASSWORD, data, { encDecAlgo })
}

// Get Brands
export const getBrands = options => {
    const { params, ...restOptions } = options || {}
    return apiClientInstance.get(url.GET_BRANDS, params, restOptions)
}

// Manage Brand
export const manageBrand = (data, options) =>
    apiClientInstance.post(url.MANAGE_BRAND, data, options)

// OFFERS
export const getCuratorOffers = options => {
    const { params, ...restOptions } = options || {}
    return apiClientInstance.get(url.GET_CURATOR_OFFERS, params, restOptions)
}

export const getOperationOffers = options => {
    const { params, ...restOptions } = options || {}
    return apiClientInstance.get(url.GET_OPERATION_OFFERS, params, restOptions)
}

export const getApproverOffers = options => {
    const { params, ...restOptions } = options || {}
    return apiClientInstance.get(url.GET_APPROVER_OFFERS, params, restOptions)
}

export const getPublishedOffers = options => {
    const { params, ...restOptions } = options || {}
    return apiClientInstance.get(url.GET_PUBLISHED_OFFERS, params, restOptions)
}

export const manageCuratorOffer = (data, options) =>
    apiClientInstance.post(url.MANAGE_CURATOR_OFFER, data, options)

export const manageOperationsOffer = (data, options) =>
    apiClientInstance.post(url.MANAGE_OPERATIONS_OFFER, data, options)

export const managePublishedOffer = (data, options) =>
    apiClientInstance.post(url.MANAGE_PUBLISHED_OFFER, data, options)

// Offer Tags
export const getOfferTags = options => {
    const { params, ...restOptions } = options || {}
    return apiClientInstance.get(url.GET_OFFER_TAGS, params, restOptions)
}

export const manageOfferTags = (data, options) =>
    apiClientInstance.post(url.MANAGE_OFFER_TAGS, data, options)

export const getOfferTagDefinitions = options => {
    const { params, ...restOptions } = options || {}
    return apiClientInstance.get(url.GET_OFFER_TAG_DEFINITIONS, params, restOptions)
}

// Offer Inclusions
export const getOfferInclusions = options => {
    const { params, ...restOptions } = options || {}
    return apiClientInstance.get(url.GET_OFFER_INCLUSIONS, params, restOptions)
}

export const manageOfferInclusions = (data, options) =>
    apiClientInstance.post(url.MANAGE_OFFER_INCLUSIONS, data, options)

// Offer Exclusions
export const getOfferExclusions = options => {
    const { params, ...restOptions } = options || {}
    return apiClientInstance.get(url.GET_OFFER_EXCLUSIONS, params, restOptions)
}

export const manageOfferExclusions = (data, options) =>
    apiClientInstance.post(url.MANAGE_OFFER_EXCLUSIONS, data, options)

// Offer Terms & Conditions
export const getOfferTermsConditions = options => {
    const { params, ...restOptions } = options || {}
    return apiClientInstance.get(url.GET_OFFER_TERMS_CONDITIONS, params, restOptions)
}

export const manageOfferTermsConditions = (data, options) =>
    apiClientInstance.post(url.MANAGE_OFFER_TERMS_CONDITIONS, data, options)

export const getOfferStateHistory = options => {
    const { params, ...restOptions } = options || {}
    return apiClientInstance.get(url.GET_OFFER_STATE_HISTORY, params, restOptions)
}

// Post Offer
export const postOffer = (data) => {
    return apiClientInstance.post(url.POST_OFFER, data)
}

// Reject Offer  
export const rejectOffer = (data) => {
    return apiClientInstance.post(url.REJECT_OFFER, data)
}

// Process Offer
export const processOffer = (data) => {
    return apiClientInstance.post(url.PROCESS_OFFER, data)
}

// Publish Offer
export const publishOffer = (data) => {
    return apiClientInstance.post(url.PUBLISH_OFFER, data)
}

// Deny Offer
export const denyOffer = (data) => {
    return apiClientInstance.post(url.DENY_OFFER, data)
}

// NOTIFICATIONS
export const getNotifications = options => {
    const { params, ...restOptions } = options || {}
    return apiClientInstance.get(url.GET_NOTIFICATIONS, params, restOptions)
}

export const manageNotification = (data, options) =>
    apiClientInstance.post(url.MANAGE_NOTIFICATION, data, options)

export const toggleNotificationReadUnread = (data, options) =>
    apiClientInstance.post(url.TOGGLE_NOTIFICATION_READ_UNREAD, data, options)

// Get Merchant Group
export const getMerchantGroup = options => {
    const { params, ...restOptions } = options || {}
    return apiClientInstance.get(url.GET_MERCHANT_GROUP, params, restOptions)
}

// Manage Merchant Group
export const manageMerchantGroup = (data, options) =>
    apiClientInstance.post(url.MANAGE_MERCHANT_GROUP, data, options)

// Get Merchant Group Communications
export const getMerchantGroupCommunications = options =>
    apiClientInstance.get(url.GET_MERCHANT_GROUP_COMMUNICATIONS, null, options)

// Manage Merchant Group Communication
export const manageMerchantGroupCommunication = (data, options) =>
    apiClientInstance.post(url.MANAGE_MERCHANT_GROUP_COMMUNICATION, data, options)

// Get Merchant Group Contacts
export const getMerchantGroupContacts = options =>
    apiClientInstance.get(url.GET_MERCHANT_GROUP_CONTACTS, null, options)

// Manage Merchant Group Contact
export const manageMerchantGroupContact = (data, options) =>
    apiClientInstance.post(url.MANAGE_MERCHANT_GROUP_CONTACT, data, options)

// Get Merchant Group Contact Communications
export const getMerchantGroupContactCommunications = options =>
    apiClientInstance.get(
        url.GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS,
        null,
        options
    )

// Manage Merchant Group Contact Communication
export const manageMerchantGroupContactCommunication = (data, options) =>
    apiClientInstance.post(
        url.MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION,
        data,
        options
    )

// Get Merchant Group Banking
export const getMerchantGroupBanking = options =>
    apiClientInstance.get(url.GET_MERCHANT_GROUP_BANKING, null, options)

// Get Merchant Group Banking Detail (List)
export const getMerchantGroupBankingDetail = options =>
    apiClientInstance.get(url.GET_MERCHANT_GROUP_BANKING, null, options)

// Add New Merchant Group Banking
export const addNewMerchantGroupBanking = (data, options) =>
    apiClientInstance.post(url.MANAGE_MERCHANT_GROUP_BANKING, data, options)

// Manage Merchant Group Banking (Activate/Deactivate)
export const manageMerchantGroupBanking = (data, options) =>
    apiClientInstance.post(url.MANAGE_MERCHANT_GROUP_BANKING, data, options)

// Toggle Merchant Group Banking Status (Activate/Deactivate)
export const toggleMerchantGroupBankingStatus = (data, options) =>
    apiClientInstance.post(url.TOGGLE_MERCHANT_GROUP_BANKING_STATUS, data, options)

// Toggle Merchant Group Banking Default (Set/Unset Default)
export const toggleMerchantGroupBankingDefault = (data, options) =>
    apiClientInstance.post(url.TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT, data, options)

// Check Merchant Group Banking Status
export const checkMerchantGroupBankingStatus = (destinationID, options) =>
    apiClientInstance.get(url.CHECK_MERCHANT_GROUP_BANKING_STATUS, null, {
        ...options,
        headers: {
            ...options?.headers,
            "input-parameters": { destinationID },
        },
    })

// Get Merchant Group Admin User
export const getMerchantGroupAdminUser = options =>
    apiClientInstance.get(url.GET_MERCHANT_GROUP_ADMIN, null, options)

// Create Merchant Group Admin User
export const createMerchantGroupAdminUser = (data, options) =>
    apiClientInstance.post(url.CREATE_MERCHANT_GROUP_ADMIN, data, options)

// Get Merchant Images
export const getMerchantImages = options =>
    apiClientInstance.get(url.GET_MERCHANT_IMAGES, null, options)

// Manage Merchant Image
export const manageMerchantImage = (data, options) =>
    apiClientInstance.post(url.MANAGE_MERCHANT_IMAGE, data, options)

// Reorder Merchant Images
export const reorderMerchantImages = (data, options) =>
    apiClientInstance.post(url.REORDER_MERCHANT_IMAGES, data, options)

// Get Merchant Attributes
export const getMerchantAttributes = options =>
    apiClientInstance.get(url.GET_MERCHANT_ATTRIBUTES, null, options)

// Manage Merchant Attribute
export const manageMerchantAttribute = (data, options) =>
    apiClientInstance.post(url.MANAGE_MERCHANT_ATTRIBUTE, data, options)

// Get Merchant Variables
export const getMerchantVariables = options =>
    apiClientInstance.get(url.GET_MERCHANT_VARIABLES, null, options)

// Create Merchant Variables
export const createMerchantVariables = (data, options) =>
    apiClientInstance.post(url.CREATE_MERCHANT_VARIABLES, data, options)

// Update Merchant Variables
export const updateMerchantVariables = (data, options) =>
    apiClientInstance.post(url.UPDATE_MERCHANT_VARIABLES, data, options)

// Get Reconciliation Frequencies
export const getReconciliationFrequencies = (options) =>
    apiClientInstance.get(url.GET_RECONCILIATION_FREQUENCIES, null, options)

// Get Merchant PINs
export const getMerchantPins = options =>
    apiClientInstance.get(url.GET_MERCHANT_PINS, null, options)

// Show Merchant PINs
export const showMerchantPins = options =>
    apiClientInstance.get(url.SHOW_MERCHANT_PINS, null, options)

// Update Merchant PINs
export const updateMerchantPins = (data, options) =>
    apiClientInstance.post(url.UPDATE_MERCHANT_PINS, data, options)

// Get Communication Channels
export const getCommChannels = options =>
    apiClientInstance.get(url.GET_COMM_CHANNELS, null, options)

// Get Currencies
export const getCurrencies = options =>
    apiClientInstance.get(url.GET_CURRENCIES, null, options)

// Get Cities
export const getCities = options =>
    apiClientInstance.get(url.GET_CITIES, null, options)

// Get Municipalities
export const getMunicipalities = options =>
    apiClientInstance.get(url.GET_MUNICIPALITIES, null, options)

// Get Supported Banks (Bank Identifier lookup for banking forms)
export const getSupportedBanks = options =>
    apiClientInstance.get(url.GET_SUPPORTED_BANKS, null, options)

// uploadBase64File
export const uploadBase64File = (data, options) =>
    apiClientInstance.post(url.UPLOAD_BASE64_FILE, data, options)

// uploadMultiPartFile
export const uploadMultiPartFile = (formData, params) => {
    const queryParams = new URLSearchParams(params).toString()
    return apiClientInstance.post(`${url.UPLOAD_MULTIPART_FILE}?${queryParams}`, formData)
}

// Get Merchants
export const getMerchants = options =>
    apiClientInstance.get(url.GET_MERCHANTS, null, options)

// Manage Merchant
export const addNewMerchant = (data, options) =>
    apiClientInstance.post(url.MANAGE_MERCHANT, data, options)

// Get Merchant Detail (using same as getMerchants with ID parameter)
export const getMerchantDetail = options => {
    const { params, ...restOptions } = options || {}
    return apiClientInstance.get(url.GET_MERCHANTS, params, restOptions)
}

// Get Merchant Communications
export const getMerchantCommunications = options =>
    apiClientInstance.get(url.GET_MERCHANT_COMMUNICATIONS, null, options)

// Manage Merchant Communication
export const manageMerchantCommunication = (data, options) =>
    apiClientInstance.post(url.MANAGE_MERCHANT_COMMUNICATION, data, options)

// Get Merchant Contacts
export const getMerchantContacts = options =>
    apiClientInstance.get(url.GET_MERCHANT_CONTACTS, null, options)

// Manage Merchant Contact
export const manageMerchantContact = (data, options) =>
    apiClientInstance.post(url.MANAGE_MERCHANT_CONTACT, data, options)

// Get Merchant Contact Communications
export const getMerchantContactCommunications = options =>
    apiClientInstance.get(url.GET_MERCHANT_CONTACT_COMMUNICATIONS, null, options)

// Manage Merchant Contact Communication
export const manageMerchantContactCommunication = (data, options) =>
    apiClientInstance.post(url.MANAGE_MERCHANT_CONTACT_COMMUNICATION, data, options)

// Get Merchant Banking
export const getMerchantBankingDetail = options =>
    apiClientInstance.get(url.GET_MERCHANT_BANKING, null, options)

// Manage Merchant Banking
export const addNewMerchantBanking = (data, options) =>
    apiClientInstance.post(url.MANAGE_MERCHANT_BANKING, data, options)

// Toggle Merchant Banking Status (Activate/Deactivate)
export const toggleMerchantBankingStatus = (data, options) =>
    apiClientInstance.post(url.TOGGLE_MERCHANT_BANKING_STATUS, data, options)

// Toggle Merchant Banking Default (Set/Unset Default)
export const toggleMerchantBankingDefault = (data, options) =>
    apiClientInstance.post(url.TOGGLE_MERCHANT_BANKING_DEFAULT, data, options)

// Check Merchant Banking Status
export const checkMerchantBankingStatus = (destinationID, options) =>
    apiClientInstance.get(url.CHECK_MERCHANT_BANKING_STATUS, null, {
        ...options,
        headers: {
            ...options?.headers,
            "input-parameters": { destinationID },
        },
    })

// Get Merchant Timings
export const getMerchantTimings = options =>
    apiClientInstance.get(url.GET_MERCHANT_TIMINGS, null, options)

// Manage Merchant Timing
export const manageMerchantTiming = (data, options) =>
    apiClientInstance.post(url.MANAGE_MERCHANT_TIMING, data, options)

// Get Merchant Tags
export const getMerchantTags = options =>
    apiClientInstance.get(url.GET_MERCHANT_TAGS, null, options)

// Manage Merchant Tag
export const manageMerchantTag = (data, options) =>
    apiClientInstance.post(url.MANAGE_MERCHANT_TAG, data, options)

// Get Tag Definitions
export const getTagDefinitions = options =>
    apiClientInstance.get(url.GET_TAG_DEFINITIONS, null, options)







// Get User Profile Info
export const getUserProfileInfo = (options) => {
    return apiClientInstance.get(url.GET_USER_PROFILE_INFO, null, options)
}

// Update User Profile
export const updateUserProfile = (data, options) => {
    return apiClientInstance.post(url.UPDATE_USER_PROFILE, data, options)
}

// Send Email Verification Code
export const sendEmailVerificationCode = (data, options) => {
    return apiClientInstance.post(url.SEND_VERIFICATION_CODE, data, options)
}

// Validate Email Verification Code
export const validateEmailVerificationCode = (data, options) => {
    return apiClientInstance.post(url.VALIDATE_VERIFICATION_CODE, data, options)
}

// Users API Functions
export const getUsers = options =>
    apiClientInstance.get(url.GET_USERS, null, options)

export const manageUser = (data, options) =>
    apiClientInstance.post(url.MANAGE_USER, data, options)

export const getAuthorizationGroups = options =>
    apiClientInstance.get(url.GET_AUTHORIZATION_GROUPS, null, options)

// Dashboard
export const getDashboard = options => {
    const { params, ...restOptions } = options || {}
    return apiClientInstance.get(url.GET_DASHBOARD, params, restOptions)
}

export {
    postForgotPwd,
    postResetPwd,
    getLogin,
    postLogout,
    refreshToken,
    getLoggedInUser,
    isUserAuthenticated,
    reportAppCrash,
    appInitLookup,
    userAppMenu,
    getUserAuthorized,
}
